import {
    Component,
    OnInit,
    Injector,
    Input,
    Output,
    EventEmitter,
    forwardRef,
    ViewChild,
    OnDestroy,
    ElementRef
} from "@angular/core";
import {
    ReferenceDataService,
    StopItem
} from "../../services/reference-data.service";
import { Subscription } from "rxjs/Subscription";
import {
    FormGroup,
    FormBuilder,
    Validators,
    AbstractControl,
    ValidatorFn,
    FormControl,
    ControlValueAccessor,
    NG_VALUE_ACCESSOR
} from "@angular/forms";
import * as _ from "lodash";
import {
    ActionUpdaterService,
    ApiError
} from "../../services/action-updater.service";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/of";
import { ModalDirective } from "ngx-bootstrap/modal";
import { modalClass } from "app/home/booking-widget-container/booking-widget-container.component";
import { letProto } from "rxjs/operator/let";
import { EventBusService } from "../../services/event-bus.service";
import { ModalPopupMainPageEventWrapper } from "../../models/app-events.model";
import { ModalPopupMainPageEvent } from "../../models/app-events-types.model";
import { TravelService } from "../../services/travel.service";

@Component({
    selector: 'gaweb-pick-stop',
    templateUrl: `./pick-stop.component.html`,
    styleUrls: ['./pick-stop.component.less'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => PickStopComponent),
            multi: true
        }
    ]
})
export class PickStopComponent
    implements OnInit, ControlValueAccessor, OnDestroy {
    @ViewChild('myInput') inputEl: ElementRef;
    @Input()
    set stops(ss: Array<StopItem>) {
        this.referenceDataService.stops = ss;
    }

    get stops() {
        return this.referenceDataService.stops;
    }
    @Input() placeholder: string;

    @Output() onStopSelected: EventEmitter<any> = new EventEmitter();
    @Output()
    onValueChanged: EventEmitter<PickStopChangeEvent> = new EventEmitter();
    @Output() onFocused: EventEmitter<void> = new EventEmitter();
    @ViewChild('childModal') public childModal: ModalDirective;
    locationEnabled: boolean;

    public config = {
        animated: true,
        keyboard: true,
        backdrop: false,
        ignoreBackdropClick: false
    };
    nearestStops: Array<StopItem>;
    public stopCtrl: FormControl = new FormControl();
    public dataSource: Observable<any>;
    public asyncSelected: string | StopItem;
    public myForm: FormGroup = new FormGroup({
        stop: this.stopCtrl
    });
    private lastResults: StopItem[];
    get value() {
        return this._value;
    }
    private _value: StopItem = null;
    @Input('value')
    set value(val: StopItem) {
        this._value = val;
        this.asyncSelected = !!val ? val.Description : '';
        this.onChange(val);
        this.onTouched();
        this.onValueChange();
    }
    onChange: any = () => {};
    onTouched: any = () => {};
    onFocus: any = () => {
        // DO NOT CALL onChange
        this.onFocused.emit();
    };
    constructor(
        private actionUpdaterService: ActionUpdaterService,
        private eventBusService: EventBusService,
        private referenceDataService: ReferenceDataService,
        private travelService: TravelService
    ) {
        this.loadStops();
    }

    public boldTerm(text: string, term: string) {
        term = term.replace('(', '\\(');
        term = term.replace(')', '\\)');
        return text.replace(
            new RegExp('(^|)(' + term + ')(|$)', 'ig'),
            '$1<b>$2</b>$3'
        );
    }

    public getStopsAsObservable = (text$: Observable<string>) => {
        return text$.map(token => {
            const StartsWithMatches: Array<StopItem> = [];
            const DescriptionMatches: Array<StopItem> = [];
            const CodeMatches: Array<StopItem> = [];
            const AddressMatches: Array<StopItem> = [];
            this.stops
                .filter((stop: StopItem) => {
                    if (!token) {
                        return false;
                    }

                    if (
                        stop.Description.toLowerCase().indexOf(
                            token.toLowerCase()
                        ) === 0
                    ) {
                        StartsWithMatches.push(stop);
                    } else if (
                        stop.Description.toLowerCase().indexOf(
                            token.toLowerCase()
                        ) !== -1
                    ) {
                        DescriptionMatches.push(stop);
                    } else if (
                        stop.Code.toLowerCase().indexOf(token.toLowerCase()) !==
                        -1
                    ) {
                        CodeMatches.push(stop);
                    } else if (
                        stop.Address.toLowerCase().indexOf(
                            token.toLowerCase()
                        ) !== -1
                    ) {
                        AddressMatches.push(stop);
                    }

                    return (
                        stop.Description.toLowerCase().indexOf(
                            token.toLowerCase()
                        ) !== -1 ||
                        stop.Code.toLowerCase().indexOf(token.toLowerCase()) !==
                            -1 ||
                        stop.Address.toLowerCase().indexOf(
                            token.toLowerCase()
                        ) !== -1
                    );
                })
                .splice(0, 10);
            this.lastResults = StartsWithMatches.concat(DescriptionMatches)
                .concat(CodeMatches)
                .concat(AddressMatches)
                .splice(0, 10);
            return this.lastResults;
        });
    };

    public typeaheadFormatter = (result: StopItem | string) => {
        if (typeof result === 'object') {
            return result.Description;
        }

        return result;
    };

    ngOnInit() {
        this.locationEnabled = true;
        this.loadStops();
    }
    private checkIfLocationEnabled() {
        if (!this.stops || this.stops.length === 0) {
            this.loadStops();
        } else {
            if (!!this.stops[0].distance) {
                this.locationEnabled = true;
                this.showNearestModalStops();
            } else {
                this.testLocationEnabled();
                // this.locationEnabled = false;
            }
        }
    }
    private async loadStops() {
        await this.travelService.getStops().then((data) => {
            try {
            data.subscribe((results) => {
                this.stops = results;
            });
            } catch {
                this.stops = data;
            }
        });
    }
    private testLocationEnabled() {
        const onSuccessfulLocationRequest = ({ coords }) => {
                if (!!this.stops) {
                    this.referenceDataService.addDistanceToStops(
                        this.stops,
                        coords
                    );
                    this.locationEnabled = true;
                    this.showNearestModalStops();
                }
            },
            onFailedLocationRequest = () => {
                this.locationEnabled = false;
            };
        this.referenceDataService.testLocationEnabled(
            onSuccessfulLocationRequest,
            onFailedLocationRequest
        );
    }
    onTypeaheadSelected = ($event: any) => {
        this.onStopSelected.emit($event.item);
        this.value = $event.item;
    };

    onNearStopSelected = ($event: StopItem) => {
        this.onStopSelected.emit($event);
        this.value = $event;
        this.hideModal();
    };
    onValueChange(): void {
        let isCorrect = false;
        let val: PickStopChangeEvent;
        if (this.asyncSelected == null) {
            val = {
                isCorrect,
                value: null
            };
            this.onValueChanged.emit(val);
            return;
        }
        let asyncSelectedStr: string;
        if (!!(<StopItem>this.asyncSelected).Description) {
            asyncSelectedStr = (<StopItem>this.asyncSelected).Description;
        } else {
            asyncSelectedStr = <string>this.asyncSelected;
        }
        if (!!this.value && asyncSelectedStr === this.value.Description) {
            isCorrect = true;
        } else {
            const v = !!this.lastResults
                ? this.lastResults.find(
                      s => s.Description.toLowerCase() === asyncSelectedStr
                  )
                : null;
            if (!!v) {
                this.value = v;
                isCorrect = true;
            }
        }
        val = {
            isCorrect,
            value: asyncSelectedStr
        };
        this.onValueChanged.emit(val);
    }
    private showNearestModalStops() {
        this.nearestStops = _(this.stops)
            .sortBy((s: StopItem) => s.distance)
            .take(8)
            .value();
        this.showModal();
    }
    onNearStopButtonClick() {
        this.onFocused.emit();
        this.locationEnabled = true;
        this.checkIfLocationEnabled();
    }

    clearSearch() {
        this.value = null;
        this.inputEl.nativeElement.focus();
    }

    registerOnChange(fn) {
        this.onChange = fn;
    }

    registerOnTouched(fn) {
        this.onTouched = fn;
    }

    writeValue(value) {
        if (value) {
            this.value = value;
        }
    }

    showModal() {
        this.childModal.show();
        const ev = new ModalPopupMainPageEvent(true);
        this.eventBusService.emit(new ModalPopupMainPageEventWrapper(ev));
        // $(`.${modalClass}`).css('position', 'inherit'); // enables the modal to overlap
    }
    hideModal() {
        this.childModal.hide();
        const ev = new ModalPopupMainPageEvent(false);
        this.eventBusService.emit(new ModalPopupMainPageEventWrapper(ev));
        // $(`.${modalClass}`).css('position', '');
    }
    ngOnDestroy(): void {
        this.hideModal();
    }
}

export interface PickStopChangeEvent {
    isCorrect: boolean;
    value: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/components/pick-stop/pick-stop.component.ts